import { useContext, useState } from 'react';
import { DataContext } from '../data/DataContext';
import { lstTypeDocument, term } from '../data/MochaData';
import { DropDown, Input, CheckBox, ModalMsgCtrl } from '../components'
import { customStyles } from '../../../../src/utils/constanst';
import { useModal } from '../hook/useModal'
import Modal from 'react-modal';

const Step1 = () => {

    const { AutoCR, setAutoCR, changeHandler } = useContext(DataContext);

    const onChange = (property: string, value: string) => setAutoCR({ ...AutoCR, [property]: value });
    const onChangeChk = (property: string, value: boolean) => {
        setAutoCR({ ...AutoCR, [property]: value });
        if (value === true) {
            modalMsg.setTextMsgWithClose(term)
        }
    };
    const modalMsg = useModal({ isloading: false, txtMsg: term } as IModalProps)


    return (
        <>
            <DropDown
                label='Tipo de identificación'
                field='typeDocument'
                valueSelect={AutoCR.typeDocument}
                dataProvider={lstTypeDocument}
                onChangeSelect={onChange}

            />

            {AutoCR.typeDocument === '1' &&
                <Input
                    id='identification'
                    label='Número de identificación'
                    value={AutoCR.identification}
                    field='identification'
                    onChange={changeHandler}
                    placeholder="Identificación"
                    type='mask'
                    mask="9-9999-9999"
                    pattern="\d-\d\d\d\d-\d\d\d\d"
                    useToolTip
                    title="Documento invalido"
                    titleToolTip='Número de identificación'
                    textToolTip='Recuerda que, al realizar una cotización como corredor, es importante ingresar tu número de ID según el tipo que hayas seleccionado.'
                />
            }

            {AutoCR.typeDocument !== '1' &&
                < Input
                    id='identification'
                    label='Número de identificación'
                    value={AutoCR.identification}
                    field='identification'
                    onChange={changeHandler}
                    useToolTip
                    titleToolTip='Número de identificación'
                    textToolTip='Recuerda que, al realizar una cotización como corredor, es importante ingresar tu número de ID según el tipo que hayas seleccionado.'

                />
            }
            <div className='mt-20' style={{ color: '#4D4D4D', fontSize: '14px' }}>
                <p><strong>Nota:</strong>  Para hacer uso de este cotizador, debes garantizar tener creado un usuario Seguronet*</p>
            </div>

            <CheckBox
                field='acceptTerms'
                label='Acepto que he leído y consecuentemente brindo mi consentimiento a SEGUROS LAFISE para el uso de mi información según lo indicado en las Políticas de Privacidad, Términos y Condiciones.'
                value={AutoCR.acceptTerms}
                onChange={onChangeChk}
                onClickLabel={() => modalMsg.setTextMsgWithClose(term)}

            />
            <ModalMsgCtrl {...modalMsg.modal} closeModal={modalMsg.hide} />

        </>
    );
}

export { Step1 };